var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Receive Authorization code")]),_c('p',[_vm._v(_vm._s(_vm.comment))])])}
var staticRenderFns = []

export { render, staticRenderFns }